import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";

import type { Dealer, DealerLocation, ExactOnlineFailure } from "models";
import type { PaginatedHistoricalInvoices } from "modules/LocationLicenseOverview/queryKeys";

type ExactFailuresResponse = {
  failures: ExactOnlineFailure[];
  nb_pages: number;
  nb_items: number;
};

export type InvoicedDealersAndLocationsResponse = {
  dealers: Dealer[];
  dealer_locations: DealerLocation[];
};

export type ExactFailuresFilters = {
  action: number | null;
  status_code: number | null;
  date_from: Date | null;
  date_to: Date | null;
  page: number;
};

export type InvoicedDealersAndLocationsFilters = {
  failed: boolean;
  date_from: Date | null;
  date_to: Date | null;
};

export type PaginatedInvoice = {
  id: number;
  data: Record<number, PaginatedHistoricalInvoices>;
};

export type PaginatedHistoryInvoices = {
  data: PaginatedInvoice[];
};

const component = "ExactFailures";

export const ExactFailuresQueryKeys = {
  failuresFilters: localQueryKey<ExactFailuresFilters>({ component, data: "failuresFilters" }),
  paginatedHistoryInvoices: localQueryKey<PaginatedHistoryInvoices>({ component, data: "paginatedHistoryInvoices" }),
  invoicedDealersAndLocationsFilters: localQueryKey<InvoicedDealersAndLocationsFilters>({ component, data: "invoicedDealersAndLocationsFilters" }),
  failures: backendQueryKey<ExactFailuresResponse>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/monitoring/failures/list" }),
  invoiceHistory: backendQueryKey<PaginatedHistoricalInvoices>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/invoices/list" }),
  invoicedDealersAndLocations: backendQueryKey<InvoicedDealersAndLocationsResponse>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/monitoring/invoicing/list" })
};
